interface EnvironmentConfig {
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
  storage: {
    baseURL: string;
  };
  environment: 'development' | 'production';
  security: {
    sessionTimeout: number; // in minutes
    maxLoginAttempts: number;
    lockoutDuration: number; // in minutes
    require2FA: boolean;
    allowedIPs?: string[];
  };
}

// Development Firebase configuration
const developmentFirebaseConfig = {
  apiKey: "AIzaSyCxW_-6qu1uVhs9vRfKjYW6foLOrBCBEmQ",
  authDomain: "yantrameditationapp-dev.firebaseapp.com",
  projectId: "yantrameditationapp-dev",
  storageBucket: "yantrameditationapp-dev.firebasestorage.app",
  messagingSenderId: "321461730575",
  appId: "1:321461730575:web:7783da1c2a805bb264127a",
  measurementId: "G-NG9HEQPCFP"
};

// Production Firebase configuration
const productionFirebaseConfig = {
  apiKey: "AIzaSyAra5_4VsXI48oy774gw80-Twpn2-wOnqk",
  authDomain: "ascend-yantra-meditation.firebaseapp.com",
  projectId: "ascend-yantra-meditation",
  storageBucket: "ascend-yantra-meditation.firebasestorage.app",
  messagingSenderId: "92213739676",
  appId: "1:92213739676:web:ff8c68378f6fa94a032d59",
  measurementId: "G-K4VC62RB29"
};

const developmentConfig: EnvironmentConfig = {
  firebase: developmentFirebaseConfig,
  storage: {
    baseURL: 'https://firebasestorage.googleapis.com/v0/b/yantrameditationapp-dev.firebasestorage.app/o/'
  },
  environment: 'development',
  security: {
    sessionTimeout: 30,
    maxLoginAttempts: 5,
    lockoutDuration: 15,
    require2FA: false,
    allowedIPs: ['127.0.0.1', 'localhost']
  }
};

const productionConfig: EnvironmentConfig = {
  firebase: productionFirebaseConfig,
  storage: {
    baseURL: 'https://firebasestorage.googleapis.com/v0/b/ascend-yantra-meditation.firebasestorage.app/o/'
  },
  environment: 'production',
  security: {
    sessionTimeout: 15,
    maxLoginAttempts: 3,
    lockoutDuration: 30,
    require2FA: true,
    allowedIPs: process.env.REACT_APP_ALLOWED_IPS?.split(',') || []
  }
};

// Determine environment based on multiple factors
const getEnvironment = (): 'development' | 'production' => {
  // 1. First check REACT_APP_ENV environment variable (highest priority)
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV as 'development' | 'production';
  }
  
  // 2. Check if we're in a browser environment and detect by domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Development domains
    const devDomains = [
      'localhost',
      'yantrameditationapp-dev.web.app',
      'yantrameditationapp-dev.firebaseapp.com',
    ];
    
    // Production domains
    const prodDomains = [
      'ascend-yantra-meditation.web.app',
      'ascend-yantra-meditation.firebaseapp.com',
      'ascendyantra.com', // your production domain
      'adminportal-ascendyantra.web.app', // admin portal domain
      'adminportal-ascendyantra.firebaseapp.com' // admin portal domain
      
      
    ];
    
    if (devDomains.includes(hostname)) {
      console.log(`🔍 Domain detected as development: ${hostname}`);
      return 'development';
    }
    
    if (prodDomains.includes(hostname)) {
      console.log(`🔍 Domain detected as production: ${hostname}`);
      return 'production';
    }
    
    // If domain doesn't match known patterns, check for dev indicators
    if (hostname.includes('dev') || hostname.includes('staging') || hostname.includes('test')) {
      console.log(`🔍 Domain contains dev indicator: ${hostname}`);
      return 'development';
    }
    
    // If we're on a Firebase hosting domain but not in our known lists, 
    // check if it contains the production project name or ascendyantra
    if (hostname.includes('ascend-yantra-meditation') || hostname.includes('ascendyantra')) {
      console.log(`🔍 Firebase production project detected: ${hostname}`);
      return 'production';
    }
    
    // If we're on a Firebase hosting domain but not in our known lists,
    // check if it contains the development project name
    if (hostname.includes('yantrameditationapp-dev')) {
      console.log(`🔍 Firebase development project detected: ${hostname}`);
      return 'development';
    }
  }
  
  // 3. Fallback to NODE_ENV
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  // 4. Default to development
  return 'development';
};

const currentEnvironment = getEnvironment();
const config: EnvironmentConfig = currentEnvironment === 'production' ? productionConfig : developmentConfig;

// Log environment information for debugging
console.log(`🌍 Environment: ${currentEnvironment}`);
console.log(`🔥 Firebase Project: ${config.firebase.projectId}`);
console.log(`🔗 Auth Domain: ${config.firebase.authDomain}`);
console.log(`📦 Storage Bucket: ${config.firebase.storageBucket}`);
if (typeof window !== 'undefined') {
  console.log(`🌐 Current Domain: ${window.location.hostname}`);
}

export default config; 